import React, { FC } from 'react';
import AccordionItem from '../accordionItem';

export type TAccordionMapProps = {
  defaultIndex: string;
  istoggleIndependent: string;
  /* eslint-disable-next-line */
  children: any;
};

const AccordionMap: FC<TAccordionMapProps> = ({ defaultIndex, istoggleIndependent, children }) => {
  const [bindIndex, setBindIndex] = React.useState(defaultIndex);

  const changeItem = (itemIndex): void => {
    setBindIndex(itemIndex !== bindIndex ? itemIndex : '');
  };

  return (
    <>
      {children.map(({ props }, index) => (
        <AccordionItem
          header={props.header}
          onclick={(): void => changeItem(props.index)}
          index={props.index}
          key={index}
          isCollapsed={bindIndex !== props.index}
          istoggleIndependent={istoggleIndependent}
        >
          {props.children}
        </AccordionItem>
      ))}
    </>
  );
};

export default AccordionMap;
